import React from "react";
import {css} from "@panda/css";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {FilterFooter} from "../search/components/filters/SearchFiltersFooter";
import {FilterBudget} from "../search/components/generic_filters/FilterBudget";

interface IProps {
    label: string;
    onClear: () => void;
    closeForm: () => void;
    onSubmit: (e: React.MouseEvent<HTMLElement>) => void;
    maxPrice?: number;
    filterAreaTestId?: string;
}

export const PropertyListFiltersBudget = (props: IProps) => {
    const {isMobile} = useUserDevice();

    // Kontrolki i lokalna stopka są rodzeństwem, żeby obszar filtra nie obejmował przycisków
    const controls = (
        <>
            <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")} mb={2}>
                {props.label}
            </Text>

            <FilterBudget maxPrice={props.maxPrice} maxDisplayLabel="Bez limitu" />
        </>
    );

    const footer = (
        <FilterFooter
            onCancel={() => {
                props.onClear();
                props.closeForm();
            }}
            onSave={(e) => {
                props.onSubmit(e);
                props.closeForm();
            }}
        />
    );

    return (
        <div className={formStyle}>
            {props.filterAreaTestId ? <div data-testid={props.filterAreaTestId}>{controls}</div> : controls}

            {!isMobile && footer}
        </div>
    );
};

const formStyle = css({
    md: {
        minWidth: "495px"
    }
});
import React from "react";
import {css} from "@panda/css";

import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {FilterFooter} from "../search/components/filters/SearchFiltersFooter";
import {FilterBudget} from "../search/components/generic_filters/FilterBudget";

interface IProps {
    label: string;
    onClear: () => void;
    closeForm: () => void;
    onSubmit: (e: React.MouseEvent<HTMLElement>) => void;
    maxPrice?: number;
    filterAreaTestId?: string;
}

export const PropertyListFiltersBudget = (props: IProps) => {
    const {isMobile} = useUserDevice();

    // Kontrolki i lokalna stopka są rodzeństwem, żeby obszar filtra nie obejmował przycisków
    const controls = (
        <>
            <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")} mb={2}>
                {props.label}
            </Text>

            <FilterBudget maxPrice={props.maxPrice} maxDisplayLabel="Bez limitu" />
        </>
    );

    const footer = (
        <FilterFooter
            onCancel={() => {
                props.onClear();
                props.closeForm();
            }}
            onSave={(e) => {
                props.onSubmit(e);
                props.closeForm();
            }}
        />
    );

    return (
        <div className={formStyle}>
            {props.filterAreaTestId ? <div data-testid={props.filterAreaTestId}>{controls}</div> : controls}

            {!isMobile && footer}
        </div>
    );
};

const formStyle = css({
    md: {
        minWidth: "495px"
    }
});
